var _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 50,
    viewBox: "0 0 89 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "registers_mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 89,
    height: 50
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.6,
    height: 49.8375,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#registers_mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.37337 49.1651C3.63711 34.7204 14.1054 23.286 44.2925 23.286C71.1175 23.286 65.9015 5.92931 89.6296 7.8316C113.358 9.73389 120.674 42.2211 120.674 42.2211",
    stroke: "url(#registers_paint0_linear)",
    strokeWidth: 1.6896,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3152 28.4786C27.0628 28.4786 28.4795 27.0619 28.4795 25.3143C28.4795 23.5668 27.0628 22.1501 25.3152 22.1501C23.5676 22.1501 22.1509 23.5668 22.1509 25.3143C22.1509 27.0619 23.5676 28.4786 25.3152 28.4786Z",
    fill: "white",
    stroke: "#1CA78D",
    strokeWidth: 2.02752
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8391 26.1053C51.5867 26.1053 53.0034 24.6886 53.0034 22.941C53.0034 21.1934 51.5867 19.7767 49.8391 19.7767C48.0915 19.7767 46.6748 21.1934 46.6748 22.941C46.6748 24.6886 48.0915 26.1053 49.8391 26.1053Z",
    fill: "white",
    stroke: "#1CA78D",
    strokeWidth: 2.02752
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#registers_filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1248 15.7461C76.6153 15.7461 78.6343 13.7264 78.6343 11.2351C78.6343 8.74371 76.6153 6.72406 74.1248 6.72406C71.6342 6.72406 69.6152 8.74371 69.6152 11.2351C69.6152 13.7264 71.6342 15.7461 74.1248 15.7461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1248 15.7461C76.6153 15.7461 78.6343 13.7264 78.6343 11.2351C78.6343 8.74371 76.6153 6.72406 74.1248 6.72406C71.6342 6.72406 69.6152 8.74371 69.6152 11.2351C69.6152 13.7264 71.6342 15.7461 74.1248 15.7461Z",
    stroke: "#30AE59",
    strokeWidth: 2.2528
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.849 87.0962V27.4507",
    stroke: "url(#registers_paint1_linear)",
    strokeWidth: 8.448,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1168 97.6966L50.1168 38.051",
    stroke: "url(#registers_paint2_linear)",
    strokeWidth: 8.448,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0661 97.6966L26.0661 38.051",
    stroke: "url(#registers_paint3_linear)",
    strokeWidth: 8.448,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "registers_filter0_d",
    x: 60.4888,
    y: -0.402344,
    width: 27.2719,
    height: 27.2748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "registers_paint0_linear",
    x1: 51.9558,
    y1: 57.7481,
    x2: 91.0366,
    y2: -8.24536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C9CB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59D004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "registers_paint1_linear",
    x1: 73.761,
    y1: 479.213,
    x2: 81.6588,
    y2: 479.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B12D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25D004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "registers_paint2_linear",
    x1: 45.9668,
    y1: 853.342,
    x2: 60.6605,
    y2: 853.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04D0C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "registers_paint3_linear",
    x1: 26.7549,
    y1: 332.58,
    x2: 31.2947,
    y2: 332.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C9CB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59D004"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisters);
export default __webpack_public_path__ + "static/media/registers.4ceebf27b123c691b571e6ebadaed8d7.svg";
export { ForwardRef as ReactComponent };